export default __webpack_public_path__ + "static/media/poster.4cbac17b.png";